import React from "react";

// React DnD
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

// Common
import {
  messagesTypeFields,
  MessageEditor,
  MoreInfoAccordion,
} from "../../Common";

const NotificationSettingsPage = ({ formik }) => {
  return (
    <>
      <MoreInfoAccordion />
      <DndProvider backend={HTML5Backend}>
        {messagesTypeFields.map((field) => {
          return (
            <MessageEditor
              key={field.id}
              formik={formik}
              field={{ ...field, multiline: true }}
              formikValue="defaultTextMessages"
            />
          );
        })}
      </DndProvider>
    </>
  );
};

export default NotificationSettingsPage;
